import { X } from "lucide-react";

export default function RemoveWishlistButton({ product, onRemove }) {
  return (
    <button
      type="button"
      onClick={() => onRemove(product.slug)}
      className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-border px-4 py-2.5 text-xs font-black uppercase transition hover:border-red-600 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-ring"
    >
      <X className="size-4" />
      Remove
    </button>
  );
}